import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Spinner } from "reactstrap";
import {
  TbRefresh,
} from "react-icons/tb";
import { getDashboardData } from "../../../services/reportesService";

import ModernDashboard from "./ModernDashboard";
import AgentsDashboard from "./AgentsDashboard";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const [userName, setUserName] = useState("");
  const [loadingStats, setLoadingStats] = useState(true);
  const [filtros, setFiltros] = useState({
    periodo: null,
    fecha_inicio: null,
    fecha_fin: null,
    contacto_id: null
  });

  // Estados para datos del dashboard
  const [dashboardData, setDashboardData] = useState(null);
  const [activeTab, setActiveTab] = useState('ot');


  useEffect(() => {
    loadAdminStats();

    // Obtener nombre del usuario del localStorage
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.get_full_name) {
      setUserName(user.get_full_name);
    } else if (user && user.username) {
      setUserName(user.username);
    }
  }, [filtros]);

  const loadAdminStats = async () => {
    setLoadingStats(true);
    try {
      console.log('Cargando datos del dashboard con filtros:', filtros);
      const response = await getDashboardData(filtros);
      console.log('Respuesta completa del dashboard:', response);
      console.log('Datos del dashboard:', response.data);
      setDashboardData(response.data);
    } catch (error) {
      console.error("Error al cargar datos del dashboard:", error);
      // En caso de error, mantener datos anteriores o mostrar mensaje
    } finally {
      setLoadingStats(false);
    }
  };




  /* Filter Logic */
  const [activeFilter, setActiveFilter] = useState('HOY');

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
    let rango = null;
    switch (filter) {
      case 'AYER': rango = 'AYER'; break;
      case 'SEMANA': rango = 'SEMANA'; break;
      case 'MES': rango = 'MES'; break;
      case 'YEAR': rango = 'YEAR'; break;
      case 'TODO': rango = 'TODO'; break;
      case 'HOY':
      default:
        rango = '';
        break;
    }
    setFiltros(prev => ({ ...prev, rango }));
  };

  const filterOptions = [
    { label: 'Hoy', value: 'HOY' },
    { label: 'Ayer', value: 'AYER' },
    { label: 'Esta Semana', value: 'SEMANA' },
    { label: 'Este Mes', value: 'MES' },
    { label: 'Este Año', value: 'YEAR' },
    { label: 'Todo', value: 'TODO' }
  ];

  // Pastel colors for filters matching the theme
  const pastel = {
    blue: '#9ec5fe',
    darkText: '#334155'
  };


  return (
    <div className="page-content">
      <Container fluid>
        {/* Header Title Only */}
        <Row className="mb-3">
          <Col xs={12}>
            <div className="admin-dashboard__header mb-0">
              <h3 className="admin-dashboard__title">
                Panel de Administración{userName ? ` - ${userName}` : ''}
              </h3>
            </div>
          </Col>
        </Row>


        {/* Control Bar: Tabs (Left) + Filters (Right) + Refresh (Far Right) */}
        <Row className="mb-4">
          <Col xs={12}>
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 bg-white p-2 rounded shadow-sm border">

              {/* Left: Navigation Tabs */}
              <div className="d-flex gap-2">
                <Button
                  color={activeTab === 'ot' ? "primary" : "light"}
                  onClick={() => setActiveTab('ot')}
                  className={`border-0 ${activeTab === 'ot' ? "px-4 fw-bold" : "px-4 text-muted"}`}
                  size="sm"
                >
                  Seguimiento de OT's
                </Button>
                <Button
                  color={activeTab === 'agents' ? "primary" : "light"}
                  onClick={() => setActiveTab('agents')}
                  className={`border-0 ${activeTab === 'agents' ? "px-4 fw-bold" : "px-4 text-muted"}`}
                  size="sm"
                >
                  Seguimiento de Agentes
                </Button>
              </div>

              {/* Center/Right: Date Filters */}
              <div className="d-flex bg-light rounded-pill p-1">
                {filterOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => handleFilterChange(option.value)}
                    className={`btn btn-sm rounded-pill px-3 fw-medium transition-all`}
                    style={{
                      backgroundColor: activeFilter === option.value ? pastel.blue : 'transparent',
                      color: activeFilter === option.value ? '#fff' : '#6c757d',
                      border: 'none',
                      fontSize: '0.85rem'
                    }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>

              {/* Far Right: Refresh */}
              <Button
                color="link"
                size="sm"
                onClick={loadAdminStats}
                disabled={loadingStats}
                className="text-decoration-none text-muted"
                title="Actualizar datos"
              >
                {loadingStats ? (
                  <Spinner size="sm" />
                ) : (
                  <TbRefresh size={20} />
                )}
              </Button>

            </div>
          </Col>
        </Row>

        {/* Dashboards */}
        {activeTab === 'ot' ? (
          <ModernDashboard
            data={dashboardData}
            loading={loadingStats}
            onFilterChange={(rango) => {
              setFiltros(prev => ({ ...prev, rango }));
            }}
          />
        ) : (
          <AgentsDashboard data={dashboardData} loading={loadingStats} />
        )}

      </Container>
    </div>
  );
};

export default AdminDashboard;